import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Component, Inject, OnInit, PLATFORM_ID, Renderer2, DOCUMENT } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { LayoutService } from './core/layout.service';
import { DocumentationService } from './views/documentation/services/documentation.service';
import { GtmService } from './core/gtm.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {
  public isHandset$: Observable<boolean>;

  constructor(
    private renderer: Renderer2,
    private layoutService: LayoutService,
    private documentationService: DocumentationService,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: object,
    private activatedRoute: ActivatedRoute,
    private gtmService: GtmService
  ) {
    this.gtmService.addGtm();
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      const html = this.document.querySelector('html');

      this.renderer.addClass(html, 'js');

      this.isHandset$ = this.layoutService.isHandset$.pipe(
        tap(isHandset =>
          isHandset ? this.renderer.removeClass(html, 'no-mobile') : this.renderer.addClass(html, 'no-mobile')
        )
      );
    }
    this.documentationService
      .getTegsAndCategoryForMd('blog', this.activatedRoute.snapshot.params['locale'] ? this.activatedRoute.snapshot.params['locale'] : 'en')
      .subscribe(res => this.documentationService.blogFromJson.next(res))

    this.documentationService
      .getTegsAndCategoryForMd('docs', this.activatedRoute.snapshot.params['locale'] ? this.activatedRoute.snapshot.params['locale'] : 'en')
      .subscribe(res => this.documentationService.docsFromJson.next(res))
  }
}
